module.exports = __webpack_public_path__ + "img/qqcwdb_logo@3x.adf14fdc.png";